export const LogState = _ => ({
  archives: [],
  logs: [],
  logsActors: [],
})
